import { useQuery } from '@tanstack/react-query';
import { DataSourceWithExtras, Transformation } from '../services/common/common.types';
import { commonService } from '../services/common/common.service';

type SidebarDataResponse = [
  DataSourceWithExtras[],
  DataSourceWithExtras[],
  Transformation[]
];

interface UseSidebarDataQueryProps {
  enabled?: boolean;
}

export const useSidebarDataQuery = ({
  enabled = true,
}: UseSidebarDataQueryProps) => {
  return useQuery<SidebarDataResponse>({
    queryKey: ['sidebar-data'],

    queryFn: async () => {
      const [
        sourceDataSources,
        targetDataSources,
        transformations,
      ] = await Promise.all([
        commonService.dataSourcesFilter({
          column_name: 'is_supported_for_source_data_source',
          value: true,
          show_schema_definition: true,
          show_prerequisite: true,
        }),

        commonService.dataSourcesFilter({
          column_name: 'is_supported_for_target_data_source',
          value: true,
          show_schema_definition: true,
          show_prerequisite: true,
        }),

        commonService.getTransformations(),
      ]);

      return [sourceDataSources, targetDataSources, transformations];
    },

    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
  });
};
